export default __webpack_public_path__ + "img/img-icon-credit@2x.adc724cbd7511d21d713aab7d6c50224.png";